<template>
  <form class="form p-2 border border-gray-1 bg-light" @submit.prevent>
    <select
      class="form-select mb-2"
      v-model="selectedYear"
      :disabled="isLocked"
    >
      <option v-for="year in years" :key="year.id" :value="year.id">{{
        year.name
      }}</option>
    </select>

    

    <select
      class="form-select mb-2"
      v-model="selectedMake"
      :disabled="isLocked"
    >
      <option v-for="make in makes" :key="make.id" :value="make.id">{{
        make.name
      }}</option>
    </select>

    <select
      class="form-select mb-2"
      v-model="selectedModel"
      :disabled="isLocked"
    >
      <option v-for="model in models" :key="model.id" :value="model.id">{{
        model.name
      }}</option>
    </select>

    <select
      class="form-select mb-2"
      v-model="selectedTrim"
      :disabled="isLocked"
    >
      <option v-for="trim in trims" :key="trim.id" :value="trim.id">{{
        trim.name
      }}</option>
    </select>

    <select
      class="form-select mb-2"
      v-model="selectedBodytype"
      :disabled="isLocked"
    >
      <option
        v-for="bodytype in bodytypes"
        :key="bodytype.id"
        :value="bodytype.id"
        >{{ bodytype.name }}</option
      >
    </select>

    <select
      class="form-select mb-2"
      v-model="selectedCity"
      :disabled="isLocked"
    >
      <option v-for="city in cities" :key="city.id" :value="city.id">{{
        city.name
      }}</option>
    </select>

    <div class="mb-2">
      <input
        type="number"
        class="form-control"
        placeholder="Mileage"
        v-model="mileage"
        :disabled="isLocked"
      />
    </div>

    <button
      class="btn btn-primary w-100"
      @click="onSubmit"
      :disabled="!proceed"
    >
      Show prediction
    </button>
  </form>
</template>

<script>
import mixin from '../mixin';

export default {
  mixins: [ mixin ],
  props: {
    onResponse: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      cities: [],
      makes: [],
      models: [],
      trims: [],
      bodytypes: [],
      years: [],

      selectedCity: -1,
      selectedMake: -1,
      selectedModel: -1,
      selectedTrim: -1,
      selectedBodytype: -1,
      selectedYear: -1,
      mileage: "",

      graphic: "fueltype",

      items: [],

      isLocked: false,
    };
  },
  async created() {
    await this.getElements();
  },
  methods: {
    async getElements() {
      if (this.isLocked) return;
      this.isLocked = true;
      const data = await this.$api.get("QSServlet7", this.params);
      
      this.setDataByParam(data, "selectedCity", "cities", "City");
      this.setDataByParam(data, "selectedMake", "makes", "Make");
      this.setDataByParam(data, "selectedModel", "models", "Model");
      this.setDataByParam(data, "selectedTrim", "trims", "Trim");
      this.setDataByParam(data, "selectedBodytype", "bodytypes", "Bodytype");
      this.setDataByParam(data, "selectedYear", "years", "Year");

      this.isLocked = false;
    },
    async predict() {
      const endpoint = "QSPredict7";
      const items = await this.$api.get(endpoint, this.params);
      this.items = items;
    },
    async onSubmit() {
      await this.predict();
      this.onResponse(this.items);
    },
  },
  computed: {
    params() {
      const params = {
        city: this.selectedCity,
        make: this.selectedMake,
        model: this.selectedModel,
        trim: this.selectedTrim,
        bodytype: this.selectedBodytype,
        year: this.selectedYear,
        graphic: this.graphic,
        mileage: this.mileage,
      };
      Object.keys(params).forEach((key) => {
        if (!params[key] || params[key] == -1) {
          delete params[key];
        }
      });
      return params;
    },
    proceed() {
      return (
        this.selectedCity != -1 &&
        this.selectedMake != -1 &&
        this.selectedModel != -1 &&
        this.selectedTrim != -1 &&
        this.selectedBodytype != -1 &&
        this.selectedYear != -1 &&
        this.mileage != ""
      );
    },
  },
  watch: {
    selectedCity() {
      this.getElements();
    },
    selectedMake() {
      this.getElements();
    },
    selectedModel() {
      this.getElements();
    },
    selectedTrim() {
      this.getElements();
    },
    selectedBodytype() {
      this.getElements();
    },
    selectedYear() {
      this.getElements();
    },
  },
};
</script>
